import { MultiSelect } from "react-multi-select-component";
import React, { useEffect, useRef, useState } from "react";
import ErrorContainer from "./ErrorContainer";

const SingleSearchSelect = ({
  selected,
  setSelected,
  options,
  label,
  deactivate = false,
  notRequired = false,
  formRegister,
  formError,
  formKey,
  setValue,
  closeOnChangedValue = true,
}) => {
  return (
    <li className={deactivate ? "deactivate-input" : ""}>
      <label className={notRequired ? "" : "required"}>{label}</label>
      <div class={`select-div input-group `}>
        <MultiSelect
          {...formRegister(formKey)}
          closeOnChangedValue={closeOnChangedValue}
          value={selected}
          onChange={(arr) => {
            const selectedOption = arr[arr.length - 1];

            if (selectedOption) {
              setSelected([selectedOption]);
              setValue(formKey, selectedOption?.value);
            } else {
              setSelected([]);
            }
          }}
          hasSelectAll={false}
          labelledBy="Promo Code"
          options={options ?? []}
        />
        {<ErrorContainer errors={formError} name={formKey} />}
      </div>
    </li>
  );
};

export default SingleSearchSelect;
